





































































































import { Vue, Component } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { HomeService } from "@/zh-website/src/views/Homes/service";
import { Input } from 'ant-design-vue';
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import { RegService } from '@common/service/base-service/reg';
@Component({
  components: { SideBar ,'a-textarea':Input.TextArea,ReadTo}
})
export default class PrivacyPersonalData extends Vue {
  isCheck = false;
  rules = {
  content: [{ required: true, message: "请输入详细描述", trigger: "blur" }],
  name: [
    { required: true, message: "请输入姓名", trigger: "blur" },
    { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" }
  ],
  telephone: [{required: true, validator: this.checkPhone, trigger: "blur" }],
  email: [{required: true, validator: this.checkEmail, trigger: "blur" }],
  code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
  industry: [{ required: true, message: "请选择请求主题", trigger: "change" }],
  withdrawnData: [{ required: true, message: "请选择请求主题", trigger: "change"}]
};
//邮箱验证
checkEmail(rule, value, callback) {
  const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  if (!value) {
    return callback(new Error("请输入邮箱"));
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback();
    } else {
      callback(new Error("请输入正确的邮箱格式"));
    }
  }, 100);
}
//手机验证
checkPhone(rule, value, callback) {
  const phoneReg = RegService.PHONE;
  if (!value) {
    return callback(new Error("请输入电话号码"));
  }
  setTimeout(() => {
    // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
    // 所以我就在前面加了一个+实现隐式转换
    if (!Number.isInteger(+value)) {
      callback(new Error("请输入数字值"));
    } else {
      if (phoneReg.test(value)) {
        callback();
      } else {
        callback(new Error("电话号码格式不正确"));
      }
    }
  }, 100);
}
codeNum=""
codeImg=""
options=[
    {title:'隐私问题咨询',value:'1'},
    {title:'隐私问题投诉',value:'2'},
    {title:'行使数据主体权利',value:'3'},
    {title:'数据泄露时间报告',value:'4'},
    {title:'其他隐私问题',value:'5'},
    {title:'联系DPO',value:'6'},
    {title:'撤销已签署的隐私协议',value:'7'}
]
withdrawBusinessOptions=[
  {title: '招聘中心-社招/校招', value: '1'},
  {title: '合作伙伴-行业专家合作-成为专家/推荐专家', value: '2'},
  {title: '合作伙伴-行业专家合作-课程合作', value: '3'},
  {title: '合作伙伴-供应商专区', value: '4'},
  {title: '合作伙伴-渠道合作-伙伴项目报备', value: '6'},
  {title: '首页-合作反馈', value: '5'},
]
ruleForm = {
    name: "",
    telephone: "",
    email: "",
    industry: "",
    content:"",
    code: "",
    withdrawnData: "",
    isBusinessSectionVisible: false
}
mounted() {
  this.getCode();
}
getCode() {
  HomeService.getCode().then(res => {
    this.codeImg = `data:image/png;base64,${res.data.code}`;
    this.codeNum = res.data.codeNum;
  });
}
resetForm(formName) {
  (this.$refs[formName] as any).resetFields();
}
changeCode() {
  this.getCode();
}
updateWithdrawSection(value) {
  if ('撤销已签署的隐私协议' == value) {
    this.ruleForm.isBusinessSectionVisible = true;
  } else {
    this.ruleForm.isBusinessSectionVisible = false;
  }
}
submitForm(formName) {
  if (!this.isCheck) {
    this.$message.error("请仔细阅读并同意隐私协议");
    return;
  }
  (this.$refs[formName] as any).validate(valid => {
    if (valid) {
      HomeService.privacyPersonal({
        "intro": this.ruleForm.content,
        "name": this.ruleForm.name,
        "telephone": this.ruleForm.telephone,
        "email": this.ruleForm.email,
        "theme": this.ruleForm.industry,
        "code": this.ruleForm.code,
        "codeNum": this.codeNum,
        "signStatus":this.isCheck,
        "withdrawnData":this.ruleForm.withdrawnData
      }).then(res => {
        this.$message.success("提交成功！");
        this.getCode();
        this.resetForm(formName);
        this.codeNum = "";
      });
    } else {
      return false;
    }
  });
}
}
